var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSideHomeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3078 1.25C11.9689 1.25 11.6925 1.52644 11.6925 1.86538V4.80769L8.44246 1.55769C8.20207 1.31731 7.79823 1.31731 7.55784 1.55769L0.346304 8.78846C0.105919 9.02885 0.105919 9.41346 0.346304 9.65385C0.586689 9.89423 0.971304 9.89423 1.21169 9.65385L8.00015 2.86538L14.8078 9.67308C14.928 9.79327 15.0915 9.86539 15.2502 9.86539C15.4088 9.86539 15.553 9.79327 15.6732 9.67308C15.9136 9.43269 15.9136 9.04808 15.6732 8.80769L13.5386 6.67308V1.86538C13.5386 1.52644 13.2622 1.25 12.9232 1.25H12.3078ZM8.00015 4L1.23092 10.7692V14.1538C1.23092 15.1731 2.05784 16 3.07707 16H12.9232C13.9425 16 14.7694 15.1731 14.7694 14.1538V10.7692L8.00015 4ZM6.76938 9.84615H9.23092C9.56986 9.84615 9.8463 10.1226 9.8463 10.4615V14.1538C9.8463 14.4928 9.56986 14.7692 9.23092 14.7692H6.76938C6.43044 14.7692 6.154 14.4928 6.154 14.1538V10.4615C6.154 10.1226 6.43044 9.84615 6.76938 9.84615Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSideHomeIco);
export default __webpack_public_path__ + "static/media/profile_side_home_ico.37d04915296a8a4ec27fb88aa8f3d44c.svg";
export { ForwardRef as ReactComponent };